import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Button, Modal } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import moment from "moment";

const NewPropertyView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state?.report;
  
  // State for modal
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  if (!data) return <div className="p-5 text-center">No Data Found</div>;

  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL || "";

  const getImageSrc = (imgPath) => {
    if (!imgPath)
      return "https://cdn-icons-png.flaticon.com/512/972/972601.png";

    if (imgPath.startsWith("http")) return imgPath;

    return `${imageBaseUrl}${imgPath}`;
  };

  // Handle image click - open modal
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage("");
  };

  return (
    <div className="visitReport">
      {/* HEADER */}
      <Row className="mb-2 mt-4">
        <h4 className="mb-0 text-center">
          <Icon.FileText className="me-1" /> Property Details
        </h4>
      </Row>

      {/* BACK BUTTON */}
      <Row className="mb-2 mt-4">
        <Col md={2}>
          <Button className="backButton" onClick={() => navigate(-1)}>
            <Icon.ArrowLeft size={20} className="me-2" /> Back
          </Button>
        </Col>
      </Row>

      {/* TABLE */}
      <Row className="outer-wrapper mx-auto mt-2">
        <div className="table-wrapper">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th style={{ width: "200px" }}>
                  <Icon.Code className="me-2" /> Reference Code
                </th>
                <td>{data?.referencePropertyCode || "-"}</td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Zone
                </th>
                <td>
                  {data?.zonename
                    ? `${data.zonename} (${data?.zoneno})`
                    : "-"}
                </td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Ward (Gat)
                </th>
                <td>{data?.gatname || "-"}</td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Property Type
                </th>
                <td>{data?.propertyType || "-"}</td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Financial Year
                </th>
                <td>{data?.financialYear || "-"}</td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Surveyor Name
                </th>
                <td>{data?.visitingPersonName || "-"}</td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Mobile
                </th>
                <td>{data?.visitingPersonContactNo || "-"}</td>
              </tr>

              <tr>
                <th>
                  <Icon.Code className="me-2" /> Visit Date
                </th>
                <td>
                  {data?.visitDate
                    ? moment(data.visitDate).format(
                        "DD MMM YYYY hh:mm A"
                      )
                    : "-"}
                </td>
              </tr>

              {/* PROPERTY IMAGE */}
              <tr>
                <th>
                  <Icon.Code className="me-2" /> Property Photo
                </th>
                <td>
                  <img
                    src={getImageSrc(data?.propertyPhoto)}
                    alt="Property"
                    style={{
                      width: 80,
                      height: 80,
                      cursor: "pointer",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                    onClick={() => handleImageClick(getImageSrc(data?.propertyPhoto))}
                    onError={(e) => {
                      e.target.src =
                        "https://cdn-icons-png.flaticon.com/512/972/972601.png";
                    }}
                  />
                </td>
              </tr>

              {/* ROAD IMAGE */}
              <tr>
                <th>
                  <Icon.Code className="me-2" /> Nearest Road Photo
                </th>
                <td>
                  <img
                    src={getImageSrc(data?.nearestRoadPhoto)}
                    alt="Road"
                    style={{
                      width: 80,
                      height: 80,
                      cursor: "pointer",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                    onClick={() => handleImageClick(getImageSrc(data?.nearestRoadPhoto))}
                    onError={(e) => {
                      e.target.src =
                        "https://cdn-icons-png.flaticon.com/512/972/972601.png";
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Row>

      {/* IMAGE MODAL */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <img
            src={selectedImage}
            alt="Full size"
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
            onError={(e) => {
              e.target.src =
                "https://cdn-icons-png.flaticon.com/512/972/972601.png";
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {/* <Button
            variant="primary"
            onClick={() => window.open(selectedImage, '_blank')}
          >
            Open in New Tab
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NewPropertyView;